module.exports = __webpack_public_path__ + "media/images/ecalls/04_how_it_works_bitcoin_wings-2821977a400cd1dd593484b2b4cbe7e7.png";